/**
 * Canal desacoplado entre el cliente Axios (fuera de React) y el AuthProvider.
 * Evita import circular: el interceptor no puede depender del contexto de React.
 */
export const SESSION_EXPIRED_EVENT = 'govia:session-expired'

export function emitSessionExpired(): void {
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
}

export function onSessionExpired(handler: () => void): () => void {
  window.addEventListener(SESSION_EXPIRED_EVENT, handler)
  return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler)
}
